__turbopack_context__.v({
  "classes": "k1-InW_classes",
  "item": "k1-InW_item",
  "list": "k1-InW_list",
  "title": "k1-InW_title",
});
